import {
    Box,
    Typography,
    Button,
    List,
    ListItem,
    ListItemContent,
    Divider,
} from "@mui/joy";
import PlanCartBox from "./PlanCartBox";
import AddonCartBox from "./AddonCartBox";
import TotalCartBox from "./TotalCartBox";
import { toast } from "react-toastify";
import { useMarketContext } from "../../contexts/MarketContext";

const Cart = () => {
    const {
        selected,
        addons,
        currentAddons,
        orgData,
        discount,
        calculateFinalPrice,
        currentExtraAddons,
        currentPlan,
        isLoaded,
        calculateFinalPriceAddon,
        calculateDiscountAddon,
        calculateNet,
        upgradeDiscount,
        isActive,
    } = useMarketContext();

    const handleCheckout = async () => {
        let operation = "nessuna";
        let today = new Date();
        let delta = 0;
        let expire =
            orgData.state.expiry_date > today
                ? new Date(orgData.state.expiry_date)
                : new Date(today.setFullYear(today.getFullYear() + 1));

        if (!isActive) {
            operation = "iscrizione";
            delta = selected.state.vehicles;
        } else if (selected && selected?.state?.id > currentPlan?.state?.id) {
            operation = "upgrade";
            delta =
                selected.state.vehicles +
                currentExtraAddons.state +
                (currentAddons.state > 0 ? currentAddons.state : 0) -
                orgData.state.vehicles;
        } else if (
            selected &&
            selected?.state?.id < currentPlan?.state?.id &&
            currentExtraAddons?.state >= 0
        ) {
            operation = "downgrade";
            delta = -1 * currentAddons.state + currentExtraAddons.state;
        } else if (!selected?.state && currentExtraAddons?.state > 0) {
            operation = "addon";
            expire = orgData.state.expiry_date;
            delta = currentExtraAddons.state;
        } else if (!selected?.state && currentExtraAddons?.state < 0) {
            operation = "removeaddon";
            expire = orgData.state.expiry_date;
            delta = currentExtraAddons.state;
        }
        const cart = {
            tipoOperazione: operation,
            pacchettoSelezionato: selected.state ?? currentPlan.state,
            pacchettoPrecedente: currentPlan.state,
            deltaVeicoli: delta,
            expiryDate: expire,
            addon: [
                {
                    id: addons.state[0].stripe_price_id,
                    label: addons.state[0].label,
                    quantita: currentExtraAddons.state,
                    prezzoUnitario: addons.state[0].price_amount,
                    totale: parseFloat(
                        addons.state[0].price_amount * currentExtraAddons.state
                    ),
                },
            ],
            scontoAutomatico:
                calculateDiscountAddon(addons.state[0].price_amount) +
                upgradeDiscount(),
            scontoUpgrade: upgradeDiscount(),
            scontoMezzi: calculateDiscountAddon(addons.state[0].price_amount),
            scontoManuale: discount.manualDiscount.state,
            scontoTotale: discount.calculate(),
            totaleNetto: calculateNet(),
        };

        console.log("[Cart]", cart);


        try {
            const res = await fetch(
                `${process.env.REACT_APP_SERVER_HOST}/org/${orgData.state.id}/marketplace/orders`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include",
                    body: JSON.stringify(cart),
                }
            );

            if (!res.ok) {
                if (res.status === 409) {
                    toast.warning("C'è già un ordine in pending");
                    return;
                }
                const err = await res.json();
                console.error("[ERRORE API]", err);
                toast.error("Errore durante il salvataggio dell’ordine");
                return;
            }

            const data = await res.json();
            console.log("[ORDINE INSERITO]", data);
            toast.success("Ordine registrato con successo!");
        } catch (error) {
            console.error("[ERRORE FATALE]", error);
            toast.error("Errore di rete durante il salvataggio dell’ordine");
        }
    };

    return (
        <>
            <Typography level="h4" mb={1}>
                Carrello
            </Typography>
            {!selected?.state && !currentExtraAddons?.state ? (
                <Typography color="neutral">
                    Nessun modulo selezionato.
                </Typography>
            ) : (
                <Box mb={2}>
                    <List>
                        {selected && selected?.state && isLoaded && (
                            <ListItem key={selected.state.stripe_price_id}>
                                <ListItemContent>
                                    <PlanCartBox
                                        selected={selected}
                                        calculateFinalPrice={
                                            calculateFinalPrice
                                        }
                                        upgradeDiscount={upgradeDiscount}
                                    />
                                </ListItemContent>
                            </ListItem>
                        )}
                        {currentExtraAddons?.state > 0 && (
                            <ListItem>
                                <ListItemContent>
                                    <AddonCartBox
                                        addons={addons}
                                        currentAddons={currentAddons}
                                        currentExtraAddons={currentExtraAddons}
                                        calculateFinalPriceAddon={
                                            calculateFinalPriceAddon
                                        }
                                        selected={selected}
                                        currentPlan={currentPlan}
                                        calculateDiscountAddon={
                                            calculateDiscountAddon
                                        }
                                        upgradeDiscount={upgradeDiscount}
                                    />
                                </ListItemContent>
                            </ListItem>
                        )}
                    </List>

                    <Divider sx={{ my: 2 }} />

                    <TotalCartBox
                        discount={discount}
                        selected={selected}
                        orgData={orgData}
                        total={0}
                        calculateFinalPrice={calculateFinalPrice}
                        currentExtraAddons={currentExtraAddons}
                        calculateFinalPriceAddon={calculateFinalPriceAddon}
                        calculateDiscountAddon={calculateDiscountAddon}
                        calculateNet={calculateNet}
                        addons={addons}
                    />

                    <Button
                        sx={{ mt: 2 }}
                        onClick={handleCheckout}
                        color="success"
                        variant="solid"
                    >
                        Procedi al pagamento
                    </Button>
                </Box>
            )}
        </>
    );
};

export default Cart;
